/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { Grid } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import * as React from "react";
import { useSelector } from "react-redux";
import { setSelectedFromDate, setSelectedToDate } from "../../../store/filters/audit/reducers";
import { auditFilterFromDateSelector, auditFilterToDateSelector } from "../../../store/filters/audit/selectors";
import { useStoreDispatch } from "../../../store/hooks";
import CustomDateTimePicker from "../DateTimePicker/DateTimePicker";
import { Button } from "../../ui/button";

const FileFilter: React.FC = () => {
  const dispatch = useStoreDispatch();

  const selectedFromDate = useSelector(auditFilterFromDateSelector);
  const selectedToDate = useSelector(auditFilterToDateSelector);
  const handalOnChangeFromDate = (dateTime: Dayjs | null | undefined) => {
    dispatch(setSelectedFromDate(dateTime));
  };
  const handalOnChangeToDate = (dateTime: Dayjs | null | undefined) => {
    dispatch(setSelectedToDate(dateTime));
  };
  const aYearAgo = dayjs().subtract(1, "year");
  const a6MonthAgo = dayjs().subtract(6, "month");
  const fromDateValue = !!selectedFromDate ? dayjs(selectedFromDate) : a6MonthAgo;
  const resetFilters = () => {
    dispatch(setSelectedFromDate(a6MonthAgo));
    dispatch(setSelectedToDate(dayjs()));
  };
  return (
    <Grid item sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <CustomDateTimePicker
        maxDate={selectedToDate}
        label="From Date"
        value={fromDateValue}
        maxDateTime={dayjs()}
        minDateTime={aYearAgo}
        handleOnChange={handalOnChangeFromDate}
      />
      <CustomDateTimePicker
        maxDateTime={dayjs()}
        minDateTime={aYearAgo}
        label="To Date"
        value={dayjs(selectedToDate)}
        handleOnChange={handalOnChangeToDate}
      />
      <Button variant="outline" size="sm" onClick={resetFilters}>Clear</Button>
    </Grid>
  );
};

export default FileFilter;
